module.exports = __webpack_public_path__ + "static/media/Sample_Proofreading_and_formatting_Before.9ad91fd4.png";